
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";

@Component({})
export default class Navigation extends Vue {
    get tabPermissions() {
        let currentPath: string = this.$route.path;
        let tabs: any;

        tabs = UserModule.navigations.find((ele: any) => {
            let flag: any = ele.find((item: any) => item.u === currentPath);
            if (flag) {
                return true;
            }
        });
        return tabs;
    }
}
